var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('span',{class:_vm.className,on:{"click":function($event){return _vm.$emit('click')}}},[_c('InlineSvg',{staticClass:"icon-svg",style:(_vm.iconStyle),attrs:{"src":_vm.icon.icon}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }